import injectionCode from '../../../preview/advanced-checkout'

const type = 'advanced'
const path = '/advance/html-node/public/'
const name = 'checkout.ejs'

const conditions = [
  {
    option: 'backend',
    type: 'different',
    value: 'java',
  },
  {
    parameter: 'buttons',
    type: 'not_includes',
    value: 'payment-buttons_3ds',
  },
]

export { type, path, name, conditions, injectionCode }
